export function not<T>(a: T[], b: T[]): T[] {
    return a.filter((value) => b.indexOf(value) === -1);
}

export function intersection<T>(a: T[], b: T[]): T[] {
    return a.filter((value) => b.indexOf(value) !== -1);
}

export function union<T>(a: T[], b: T[]): T[] {
    return [...a, ...not(b, a)];
}

export function notObject(a: any[], b: any[], id: string): any[] {
    return a.filter((valueA: any) => !(b?.some((valueB: any) => String(valueA[id]).toLocaleLowerCase() === String(valueB[id]).toLocaleLowerCase())));
}